export default "__VITE_PUBLIC_ASSET__17520406__"